// 转换token存储位置
import Cookies from 'js-cookie'

const TokenKey = 'loginToken'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}


const TokenKey3D = 'loginToken3d'

export function getToken3D() {
  return Cookies.get(TokenKey3D)
}

export function setToken3D(token) {
  return Cookies.set(TokenKey3D, token)
}

export function removeToken3D() {
  return Cookies.remove(TokenKey3D)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js